"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateInviteTimeRequest = void 0;
var UpdateInviteTimeRequest = /** @class */ (function () {
    function UpdateInviteTimeRequest() {
    }
    return UpdateInviteTimeRequest;
}());
exports.UpdateInviteTimeRequest = UpdateInviteTimeRequest;
;
//# sourceMappingURL=updateInviteTime.request.js.map